"use client"

import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, max = 100, ...props }, ref) => {
  // `value` must reach Radix Root or the bar reports data-state="indeterminate" with no
  // aria-valuenow — it was previously destructured away and only used for the visual transform.
  // Clamped, and only forwarded when finite, so Radix never receives an out-of-range value.
  const safeValue =
    typeof value === "number" && Number.isFinite(value) ? Math.min(Math.max(value, 0), max) : null;

  return (
    <ProgressPrimitive.Root
      ref={ref}
      value={safeValue}
      max={max}
      className={cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-subtle-bg",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="h-full w-full flex-1 bg-primary transition-all"
        style={{ transform: `translateX(-${100 - ((safeValue ?? 0) / max) * 100}%)` }}
      />
    </ProgressPrimitive.Root>
  );
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
